const REFERRAL_KEY = 'hangrily_referral_code';

export function getReferralCode(userId) {
  if (!userId) return null;
  // Generate a deterministic referral code from user ID
  const code = 'HNG-' + userId.substring(0, 8).toUpperCase();
  return code;
}

export function getReferralLink(userId) {
  const code = getReferralCode(userId);
  if (!code) return null;
  return `https://hangrily.app/register?ref=${code}`;
}

export function getStoredReferralCode() {
  return localStorage.getItem(REFERRAL_KEY);
}

export function storeReferralCode(code) {
  if (code) {
    localStorage.setItem(REFERRAL_KEY, code);
  }
}

export function clearStoredReferralCode() {
  localStorage.removeItem(REFERRAL_KEY);
}

export function getReferralStats(stats) {
  return {
    totalReferred: stats?.referralCount || 0,
    premiumWeeksEarned: stats?.referralWeeksEarned || 0,
  };
}

export function shareReferral(userId) {
  const link = getReferralLink(userId);
  if (!link) return;

  const text = `I use Hangrily to pick restaurants in 2 minutes. Try it and we both get a free week of Premium! ${link}`;

  if (navigator.share) {
    navigator.share({
      title: 'Try Hangrily - Restaurant Decision App',
      text: text,
      url: link,
    });
  } else {
    navigator.clipboard.writeText(text);
    return 'copied';
  }
  return 'shared';
}
